// __webpack_public_path__ = '//www.123123.com/ec/public-knowledge/release/';
if (window.cdn) {
  __webpack_public_path__ = window.cdn + '/h5/doc/';
}
